import type { NavContextType } from "src/components/navigation/NavContext"
import VerifyEmail from "src/screens/auth/VerifyEmail"
import Logout from "src/screens/auth/Logout"
import SendVerifyEmail from "src/screens/auth/SendVerifyEmail"
import { GuestShellLayout } from "src/components/ui/GuestShellLayout"

export const UnverifiedRoutes = ():NavContextType => ({
    routes: [
        {
            path: '/',
            element: <GuestShellLayout  />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <SendVerifyEmail />, breadcrumb: 'Home' },
                { path: "logout", element: <Logout />, breadcrumb: 'Logout' },
                { path: "verify-email", element: <SendVerifyEmail />, breadcrumb: 'Verify Email' },
                { path: "verify", element: <VerifyEmail />, breadcrumb: 'Verify Email' },
                { path: "*", element: <SendVerifyEmail />, breadcrumb: 'Not Found' }
            ]
        }
    ],
    menu: [
        {
            to: '/logout',
            label: 'Logout',
            icon: 'logout'
        }
    ],
    mobile: [],
    overlays: []
})
